// Begin React Router :' )
import { BrowserRouter, Routes, Route } from 'react-router-dom'
// import { WalletProvider } from './contexts/WalletContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import BaseLayout from './components/layouts/Base'
import DemoLayout from './components/layouts/Demo'
import { Home, About, ICO, Features, Marketplace, Transparency, Support, Dashboard } from './pages'
import { TypographyDemo, ColorsDemo, IconsDemo, ButtonsDemo, ElementsDemo } from './pages/demos'

function App() {
    return (
        // <WalletProvider>
            <BrowserRouter>
                <Routes>
                    {/* Main app routes */}
                    <Route element={<BaseLayout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/ICO" element={<ICO />} />
                        <Route path="/features" element={<Features />} />
                        <Route path="/marketplace" element={<Marketplace />} />
                        <Route path="/transparency" element={<Transparency />} />
                        <Route path="/support" element={<Support />} />
                        <Route path="/dashboard" element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        } />
                    </Route>

                    {/* Demo routes; comment out in production */}
                    <Route element={<DemoLayout />}>
                        {/* STANDARD COMPONENT DEMOS; please reference if contributing */}
                        <Route path="/demos/typography" element={<TypographyDemo />} />
                        <Route path="/demos/colours" element={<ColorsDemo />} />
                        <Route path="/demos/icons" element={<IconsDemo />} />
                        <Route path="/demos/buttons" element={<ButtonsDemo />} />
                        <Route path="/demos/elements" element={<ElementsDemo />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        // </WalletProvider>
    )
}

export default App